<template>
  <div class="TdSearch_layout" v-if="isShow">
    <el-form v-if="SearchItem.isCustSearch || !isShowCustomize" class="SearchForm" label-position="right" :inline="true" label-width="86px" size="mini">
      <template v-for="(item,index) in SearchItem.searchList">
        <!-- 普通输入框 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'input'" :key="index + 'search'" :label="item.label" :title="item.title">
          <el-input style="width: 194px;" v-model="searchForm.inputLike[item.prop]" :placeholder="item.placeholder" clearable>
          </el-input>
        </el-form-item>
        <!-- 普通输入框 加宽-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'inputwiden'" :key="index + 'search'" :label="item.label" :title="item.title">
          <el-input style="width: 484px;" v-model="searchForm.inputLike[item.prop]" :placeholder="item.placeholder" clearable>
          </el-input>
        </el-form-item>
        <!-- 时间段选择框 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'datetimerange'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-date-picker style="width: 484px;" v-model="searchForm.dateList[item.prop]" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :unlink-panels="true" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <!-- 时间段选择框 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'datetimefourday'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-date-picker style="width: 484px;" v-model="searchForm.dateList[item.prop]" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :unlink-panels="true" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <!-- 时间段可清空选择框 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'datetimeclear'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-date-picker style="width: 484px;" v-model="searchForm.dateList[item.prop]" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :unlink-panels="true" :clearable="true">
          </el-date-picker>
        </el-form-item>
        <!-- 月份段选择框 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'monthrange'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-date-picker style="width: 484px;" v-model="searchForm.dateList[item.prop]" type="monthrange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" format="yyyy年MM月" value-format="yyyy-MM" :unlink-panels="true" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <!-- 时间段默认一个月选择框 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'datetimeMonthRange'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-date-picker style="width: 484px;" v-model="searchForm.dateList[item.prop]" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :unlink-panels="true" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <!-- 月份选择框 带快捷-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'dateMonthRange'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-date-picker style="width: 484px;" v-model="searchForm.dateList[item.prop]" type="monthrange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" format="yyyy年MM月" value-format="yyyy-MM" :picker-options="pickerMothOptions" :unlink-panels="true">
          </el-date-picker>
        </el-form-item>
        <!-- 月份选择框 单月-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'dateMonth'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-date-picker style="width: 194px;" v-model="searchForm.dateList[item.prop]" type="month" format="yyyy年MM月" value-format="yyyy-MM" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <!-- input带输入建议 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'inputurl'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-autocomplete style="width: 194px;" class="inline-input" v-model="searchForm.inputLike[item.prop]" value-key="lable" :fetch-suggestions="(queryString, cb)=>{inputQuerySearch(queryString, cb, index)}" :placeholder="item.placeholder" clearable>
          </el-autocomplete>
        </el-form-item>
        <!--项目名称 模糊查询&&精确查询-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'separeteSearch'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-forwarding-fuzzy style="width: 194px;" :v-model="separeteSearchForm" :placeholder="item.placeholder" clearable
          @change="handleChange" @clickSelect="clickSelect">
          </d2-forwarding-fuzzy>
        </el-form-item>
        <!-- selectOption多选-->
          <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectmoreopt'"  :key="index + 'search'" :label="item.label" :title="item.title">
            <el-select style="width: 194px;" v-model="searchForm.moreList[item.prop]" :multiple="true" filterable remote reserve-keyword collapse-tags :placeholder="item.placeholder" clearable>
              <el-option v-for="items in JSON.parse(item.editOptions)" :key="items.value" :label="items.label" :value="items.value"></el-option>
            </el-select>
          </el-form-item>
        <!-- selectOption单选-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectopt'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-select style="width: 194px;" v-model="searchForm.oneList[item.prop]" :multiple="false" filterable remote reserve-keyword collapse-tags :placeholder="item.placeholder" clearable>
            <el-option v-for="items in JSON.parse(item.editOptions)" :key="items.value" :label="items.label" :value="items.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- selectDict 字典多选-->
        <el-form-item  v-if="item.isShowSearch === '0' && item.searchType === 'selectmoredict'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-select style="width: 194px;" v-model="searchForm.moreList[item.prop]" :multiple="true" filterable reserve-keyword collapse-tags :placeholder="item.placeholder" clearable>
            <el-option v-for="items in item.editOptions" :key="items.value" :label="items.label" :value="items.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- selectDict 字典单选-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectdict'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-select style="width: 194px;" v-model="searchForm.oneList[item.prop]" :multiple="false" filterable reserve-keyword collapse-tags :placeholder="item.placeholder" clearable>
            <el-option v-for="items in item.editOptions" :key="items.value" :label="items.label" :value="items.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- selectUser 用户多选-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectmoreuser'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-select style="width: 194px;" v-model="searchForm.moreList[item.prop]" :multiple="true" filterable remote reserve-keyword collapse-tags :placeholder="item.placeholder" clearable>
            <el-option v-for="items in nextList" :key="items.value" :label="items.label" :value="items.username">
              <span style="float: left">{{ items.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px;margin-right:20px">{{ items.username }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- selectUser 用户单选-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectuser'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-select style="width: 194px;" v-model="searchForm.oneList[item.prop]" :multiple="false" filterable remote reserve-keyword collapse-tags :placeholder="item.placeholder" clearable>
            <el-option v-for="items in nextList" :key="items.value" :label="items.label" :value="items.username">
              <span style="float: left">{{ items.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px;margin-right:20px">{{ items.username }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- selectcustomer 发货单位单选 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectcustomer'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-forwarding style="width: 194px;" v-model="searchForm.oneList[item.prop]" :placeholder="item.placeholder" clearable>
          </d2-forwarding>
        </el-form-item>
        <!-- selectsupplier 收货单位单选 -->
<!--        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectsupplier'"  :key="index + 'search'" :label="item.label" :title="item.title">-->
<!--          <d2-receiving style="width: 194px" v-model="searchForm.oneList[item.prop]" :placeholder="item.placeholder" clearable>-->
<!--          </d2-receiving>-->
<!--        </el-form-item>-->
        <!-- selectaddress 地址单选 始发地、目的地 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectaddress'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-cascader style="width: 194px;" v-model="searchForm.oneList[item.prop]" :placeholder="item.placeholder" clearable>
          </d2-cascader>
        </el-form-item>
        <!-- selectcarrier 承运单位单选 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectcarrier'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-bussup style="width: 194px;" v-model="searchForm.oneList[item.prop]" :placeholder="item.placeholder" clearable>
          </d2-bussup>
        </el-form-item>
        <!-- selectdept 法人公司单选-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectcompany'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-company-moreselect style="width: 194px;" v-model="searchForm.oneList[item.prop]" :multiple="false" :placeholder="item.placeholder" clearable>
          </d2-company-moreselect>
        </el-form-item>
          <!-- selectdept 法人公司单选 默认当前法人公司-->
          <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectmorecompany'"  :key="index + 'search'" :label="item.label" :title="item.title">
              <d2-company-default style="width: 194px;" v-model="searchForm.moreList[item.prop]" :multiple="true" :placeholder="item.placeholder" clearable>
              </d2-company-default>
          </el-form-item>
        <!-- selectdept 部门多选-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectmoredept'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-dept-moreselect style="width: 194px;" v-model="searchForm.moreList[item.prop]" :multiple="true" :placeholder="item.placeholder" clearable>
          </d2-dept-moreselect>
        </el-form-item>
        <!-- selectdept 只有业务(项目)的部门 多选-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectoperationdept'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-dept-operation style="width: 194px;" v-model="searchForm.moreList[item.prop]" :multiple="true" :placeholder="item.placeholder" clearable>
          </d2-dept-operation>
        </el-form-item>
        <!-- selectbank 银行账户多选 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectbank'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-bank-moreselect style="width: 194px;" v-model="searchForm.moreList[item.prop]" :multiple="true" :placeholder="item.placeholder" clearable>
          </d2-bank-moreselect>
        </el-form-item>
        <!-- selectbuyer 购买方、销售方单选 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectbuyer'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-buyer style="width: 194px;" v-model="searchForm.oneList[item.prop]" :placeholder="item.placeholder" clearable>
          </d2-buyer>
        </el-form-item>
        <!-- selectsettleobj 结算对象单选 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectsettleobj'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-objinput-select style="width: 194px;" v-model="searchForm.oneList[item.prop]" :placeholder="item.placeholder" clearable>
          </d2-objinput-select>
        </el-form-item>
          <!-- selectobjinput 结算对象单选 输入不会清空、支持模糊查询-->
          <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectobjinput'"  :key="index + 'search'" :label="item.label" :title="item.title">
              <d2-objinput style="width: 194px;" v-model="searchForm.inputLike[item.prop]" :placeholder="item.placeholder" clearable>
              </d2-objinput>
          </el-form-item>
        <!-- selectUnitobj 结算单位单选 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectUnitobj'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-mdmselect style="width: 194px;" v-model="searchForm.oneList[item.prop]" :placeholder="item.placeholder" clearable>
          </d2-mdmselect>
        </el-form-item>
        <!-- 项目管理 是否启用 默认启用 单选-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectactive'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-select style="width: 194px;" v-model="searchForm.oneList[item.prop]" :multiple="false" filterable remote reserve-keyword collapse-tags :placeholder="item.placeholder" clearable>
            <el-option v-for="items in JSON.parse(item.editOptions)" :key="items.value" :label="items.label" :value="items.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 中转库存、航空库存 阶段 默认一阶段 单选 不可清空-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectDefault'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-select style="width: 194px;" v-model="searchForm.oneList[item.prop]" filterable remote reserve-keyword :placeholder="item.placeholder" :disabled="disabledStatus">
            <el-option v-for="items in JSON.parse(item.editOptions)" :key="items.value" :label="items.label" :value="items.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 应收账单 单据小类多选 默认全选-->
        <el-form-item  v-if="item.isShowSearch === '0' && item.searchType === 'selectsubdoctype'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-select style="width: 194px;" v-model="searchForm.moreList[item.prop]" :multiple="true" filterable reserve-keyword collapse-tags :placeholder="item.placeholder" clearable>
            <el-option v-for="items in item.editOptions" :key="items.value" :label="items.label" :value="items.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 应收账单 结算单位id查询单选 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectReceiverId'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-receiverId style="width: 194px;" v-model="searchForm.oneList[item.prop]" :placeholder="item.placeholder" sourcetype="cus" clearable>
          </d2-receiverId>
        </el-form-item>
        <!-- 应收账单 项目名称id查询单选 -->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'selectSenderId'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <d2-senderId style="width: 194px;" v-model="searchForm.oneList[item.prop]" :placeholder="item.placeholder" clearable>
          </d2-senderId>
        </el-form-item>
        <!-- 运价统计报表 统计类型查询条件默认为二级城市且不能清空-->
        <el-form-item v-if="item.isShowSearch === '0' && item.searchType === 'statisticalType'"  :key="index + 'search'" :label="item.label" :title="item.title">
          <el-select style="width: 194px;" v-model="searchForm.oneList[item.prop]" :multiple="false" filterable remote reserve-keyword collapse-tags :placeholder="item.placeholder" :clearable="false">
            <el-option v-for="items in JSON.parse(item.editOptions)" :key="items.value" :label="items.label" :value="items.value"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item>
        <el-button style="margin-left: 32px;" :loading="loading" icon="el-icon-search" type="primary" @click="submitForm('searchForm')">{{loading ? '..' : '查询'}}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('searchForm')">重置</el-button>
        <el-button v-if="isShowCustomize" icon="el-icon-setting" @click="onChangeCustomize" title="自定义查询界面">定义</el-button>
        <slot name="extraButtons"></slot>
      </el-form-item>
    </el-form>
    <el-form v-else v-model="searchForm" class="SearchTdForm" :inline="true" size="mini">
          <el-form-item title="归属条件查询" v-if="nextList">
            <el-radio-group v-model="searchForm.operator" @change="branceChange">
              <el-radio-button :label="0">全部</el-radio-button>
              <el-radio-button :label="1">我的</el-radio-button>
              <el-radio-button :label="2">我组员</el-radio-button>
            </el-radio-group>
            <el-select v-if="searchForm.operator === 2" v-model="searchForm.moreList['createUser']" placeholder="我的组员" filterable multiple collapse-tags clearable style="width:210px;margin-left:5px;vertical-align:middle;">
              <el-option v-for="item in nextList" :key="item.value" :label="item.label" :value="item.username">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px;margin-right:20px">{{ item.username }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间" title="新增内容时间">
            <el-date-picker v-model="searchForm.dateList['createTime']" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :unlink-panels="true" style="width:350px"> <!--v-model="create_time"-->
            </el-date-picker>
          </el-form-item>
          <el-form-item title="腾大神级万能查询">
            <el-input placeholder="请输入查询内容" v-model="searchForm.inputLike[wnsearch]" class="input-with-select" clearable>
              <el-select v-model="wnsearch" slot="prepend" filterable clearable style="width:150px" placeholder="万能查询">
                <div v-for="(item,index) in SearchItem.searchList" :key="index">
                  <el-option v-if="item.isShowSearch === '0'"  :label="item.label" :value="item.prop" :title="item.title"></el-option>
                </div>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('searchForm')">查询</el-button>
            <el-button @click="resetForm('searchForm')">重置</el-button>
          </el-form-item>
        </el-form>
    <d2-container-query-setting v-if="dialogVisible.show" :settingCode="dialogVisible" @onSave="onSave" @closeClick="settingClose"></d2-container-query-setting>
  </div>
</template>
<script>

import { getBranchUser } from '@/api/admin/user'
import { mapState } from 'vuex'
import { downValues } from '@/tdcommon/beeutil'
import { getSearchUser, dynamic } from '@/api/sys.ui'
import { getdict } from '@api/admin/dict'
import { validatenull } from '@/tdcommon/validate'
import dayjs from 'dayjs'
import { getDecodeStore, removeStore, setEncodeStore } from '@/tdcommon/store'

export default {
  name: 'd2-container-query',
  props: {
    SearchItem: {
      type: Object,
      default: () => {
        return {
          isCustSearch: false,
          searchList: []
        }
      }
    },
    ModularName: {
      type: String,
      default: () => ''
    },
    noinList: {
      type: Object,
      default: () => {}
    },
    dateList: {
      type: Object,
      default: () => {}
    },
    // 查询条件在 客户引入 显示
    isShowCustomer: {
      type: Boolean,
      default: () => false
    },
    // 查询条件在 供应商引入 显示
    isShowSupplier: {
      type: Boolean,
      default: () => false
    },
    // 查询条件在 发货单位 显示
    isShowForwarding: {
      type: Boolean,
      default: () => false
    },
    // 查询条件在 承运单位 显示
    isShowCarrier: {
      type: Boolean,
      default: () => false
    },
    // 查询条件在 车辆档案 显示
    isShowVehiclefile: {
      type: Boolean,
      default: () => false
    },
    // 是否显示自定义按钮
    isShowCustomize: {
      type: Boolean,
      default: () => true
    },
    // 是否显示万能查询
    isShowWnsearch: {
      type: Boolean,
      default: () => true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    dynamicType: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      dialogVisible: { title: '自定义查询', show: false, isSetting: false, sysCheck: '启用自定义查询界面', DataTransfer: [] },
      // 日期组件初始信息
      pickerOptions: {
        shortcuts: [{
          text: '昨天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '当天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime())
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近两个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一年',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 12)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      pickerMothOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      // 下级用户信息
      nextList: [],
      isShow: true,
      isShowTime: false,
      wnsearch: '',
      firstLoad: true,
      lazyLoadTime: 900,
      searchForm: {
        inputLike: {},
        dateList: {},
        moreList: {},
        oneList: {},
        noinList: this.noinList
      },
      changeValue: '',
      clickSelectVal: {},
      blurProp: '',
      separeteSearchForm: {},
      disabledStatus: false
    }
  },
  computed: {
    ...mapState('d2admin/user', [
      'info'
    ])
  },
  created () {
    this.getSearchUI()
  },
  methods: {
    firstSearchLoad (state, param) {
      let searchForm = {
        inputLike: {},
        dateList: {},
        moreList: {},
        oneList: {},
        noinList: this.noinList
      }
      if (state === 'khQuotation') { // 客户管理 跳转 报价单 给客户名称查询框赋值
        searchForm.inputLike = { entryName: param.customerName }
      }
      this.searchForm = searchForm
    },
    initSearchData () {
      let _this = this
      if (_this.firstLoad === true) {
        setTimeout(function () {
          _this.submitForm()
        }, _this.lazyLoadTime)
      } else {
        _this.submitForm()
      }
    },
    // 取得查询条件界面参数
    getSearchUI () {
      this.isShow = false
      let searchForm = getDecodeStore({ name: 'se' + this.ModularName })
      if (validatenull(searchForm)) {
        getSearchUser(this.ModularName).then(response => {
          this.SearchItem.isCustSearch = response.data.isCustSearch
          this.SearchItem.searchList = response.data.searchList
          this.loadDefaultData(response.data.searchList)
          this.loadMonthDefaultData(response.data.searchList)
          this.loadMonthDefault(this.SearchItem.searchList)
          this.loadDefaultCompany(response.data.searchList)
          this.loadDefaultActive(response.data.searchList)
          this.getShowDownValues(0)
          this.isShow = true
        }).catch(() => {
          this.isShow = true
        })
      } else {
        this.SearchItem.isCustSearch = searchForm.isCustSearch
        this.SearchItem.searchList = searchForm.searchList
        this.loadDefaultData(this.SearchItem.searchList)
        this.loadMonthDefaultData(this.SearchItem.searchList)
        this.loadMonthDefault(this.SearchItem.searchList)
        this.loadDefaultCompany(this.SearchItem.searchList)
        this.loadDefaultActive(this.SearchItem.searchList)
        this.isShow = true
      }
      this.getBranchUser()
    },
    getRecentlyXDays () {
      let defaultDates = []
      defaultDates[0] = dayjs().add(-6, 'day').format('YYYY-MM-DD')
      defaultDates[1] = dayjs(new Date()).format('YYYY-MM-DD')
      return defaultDates
    },
    getRecentlyFourDays () {
      let defaultDates = []
      defaultDates[0] = dayjs().add(-3, 'day').format('YYYY-MM-DD')
      defaultDates[1] = dayjs(new Date()).format('YYYY-MM-DD')
      return defaultDates
    },
    getRecentlyXMonth () {
      let defaultDates = []
      defaultDates[0] = dayjs().add(-1, 'month').format('YYYY-MM')
      defaultDates[1] = dayjs().add(-1, 'month').format('YYYY-MM')
      return defaultDates
    },
    getXMonth () {
      let defaultDates = ''
      defaultDates = dayjs().add(0, 'month').format('YYYY-MM')
      return defaultDates
    },
    loadDefaultData (serverSearchList) {
      let searchFormTemp = this.copyDeepData(this.searchForm)
      if (serverSearchList && serverSearchList.length > 0) {
        for (var i = 0; i < serverSearchList.length; i++) {
          const searchModel = serverSearchList[i]
          if (searchModel.isShowSearch === '0' && searchModel.searchType === 'datetimerange') {
            searchFormTemp.dateList[searchModel.prop] = this.getRecentlyXDays()
            break
          }
          if (searchModel.isShowSearch === '0' && (searchModel.searchType === 'monthrange' || searchModel.searchType === 'dateMonthRange')) {
            searchFormTemp.dateList[searchModel.prop] = this.getRecentlyXMonth()
            break
          }
          if (searchModel.isShowSearch === '0' && searchModel.searchType === 'datetimefourday') {
            searchFormTemp.dateList[searchModel.prop] = this.getRecentlyFourDays()
            break
          }
        }
        this.searchForm = searchFormTemp
      }
      this.firstLoad = false
    },
    getMonthRecentlyXDays () {
      let defaultDates = []
      defaultDates[0] = dayjs().add(-30, 'day').format('YYYY-MM-DD')
      defaultDates[1] = dayjs(new Date()).format('YYYY-MM-DD')
      return defaultDates
    },
    // 默认一个月查询
    loadMonthDefaultData (serverSearchList) {
      let searchFormTemp = this.copyDeepData(this.searchForm)
      if (serverSearchList && serverSearchList.length > 0) {
        for (var i = 0; i < serverSearchList.length; i++) {
          const searchModel = serverSearchList[i]
          if (searchModel.isShowSearch === '0' && searchModel.searchType === 'datetimeMonthRange') {
            searchFormTemp.dateList[searchModel.prop] = this.getMonthRecentlyXDays()
            break
          }
        }
        this.searchForm = searchFormTemp
      }
      this.firstLoad = false
    },
    loadMonthDefault (serverSearchList) {
      let searchFormTemp = this.copyDeepData(this.searchForm)
      if (serverSearchList && serverSearchList.length > 0) {
        for (var i = 0; i < serverSearchList.length; i++) {
          const searchModel = serverSearchList[i]
          if (searchModel.isShowSearch === '0' && (searchModel.searchType === 'dateMonth')) {
            searchFormTemp.dateList[searchModel.prop] = this.getXMonth()
            break
          }
        }
        this.searchForm = searchFormTemp
      }
      this.firstLoad = false
    },
    getDefaultCompany () {
      let defaultCompany = ''
      defaultCompany = this.info.companyCode
      return defaultCompany
    },
    // 默认当前法人公司 selectmorecompany
    loadDefaultCompany (serverSearchList) {
      let searchFormTemp = this.copyDeepData(this.searchForm)
      if (serverSearchList && serverSearchList.length > 0) {
        for (var i = 0; i < serverSearchList.length; i++) {
          const searchModel = serverSearchList[i]
          if (searchModel.isShowSearch === '0' && searchModel.searchType === 'selectmorecompany') {
            searchFormTemp.moreList[searchModel.prop] = this.getDefaultCompany()
            break
          }
        }
        this.searchForm = searchFormTemp
      }
      this.firstLoad = false
    },
    // 统计类型
    getDefaultStatisticalType () {
      let defaultActive = ''
      defaultActive = '1'
      return defaultActive
    },
    // // 统计类型 默认二级城市
    // loadDefaultStatisticalType (serverSearchList) {
    //   let searchFormTemp = this.copyDeepData(this.searchForm)
    //   if (serverSearchList && serverSearchList.length > 0) {
    //     for (var i = 0; i < serverSearchList.length; i++) {
    //       const searchModel = serverSearchList[i]
    //       if (searchModel.isShowSearch === '0' && searchModel.searchType === 'statisticalType') {
    //         searchFormTemp.oneList[searchModel.prop] = this.getDefaultStatisticalType()
    //         break
    //       }
    //     }
    //     this.searchForm = searchFormTemp
    //   }
    //   this.firstLoad = false
    // },
    // 默认启用 '0'
    getDefaultActive () {
      let defaultActive = ''
      defaultActive = '0'
      return defaultActive
    },
    // 默认一阶段
    getDefaultValue (type) {
      if (validatenull(type)) {
        let defaultActive = ''
        defaultActive = '1'
        this.disabledStatus = false
        return defaultActive
      } else {
        let defaultActive = ''
        defaultActive = type
        this.disabledStatus = true
        return defaultActive
      }
    },
    // 是否启用 默认启用
    loadDefaultActive (serverSearchList) {
      let searchFormTemp = this.copyDeepData(this.searchForm)
      if (serverSearchList && serverSearchList.length > 0) {
        for (var i = 0; i < serverSearchList.length; i++) {
          const searchModel = serverSearchList[i]
          if (searchModel.isShowSearch === '0' && searchModel.searchType === 'selectactive') {
            searchFormTemp.oneList[searchModel.prop] = this.getDefaultActive()
            break
          }
          if (searchModel.isShowSearch === '0' && searchModel.searchType === 'selectDefault') {
            searchFormTemp.oneList[searchModel.prop] = this.getDefaultValue(this.dynamicType)
            break
          }
          if (searchModel.isShowSearch === '0' && searchModel.searchType === 'statisticalType') {
            searchFormTemp.oneList[searchModel.prop] = this.getDefaultStatisticalType()
            break
          }
        }
        this.searchForm = searchFormTemp
      }
      this.firstLoad = false
    },
    copyDeepData (data) {
      return JSON.parse(JSON.stringify(data))
    },
    // 整理下拉表信息
    getShowDownValues (index) {
      if (index === this.SearchItem.searchList.length) {
        setEncodeStore('se' + this.ModularName, this.SearchItem)
        this.isShow = true
        return
      }
      if (this.SearchItem.searchList[index].isShowSearch === '0' && !validatenull(this.SearchItem.searchList[index].dictType)) {
        getdict(this.SearchItem.searchList[index].dictType).then(response => {
          this.SearchItem.searchList[index].editOptions = response.data
          this.getShowDownValues(index + 1)
        }).catch(() => {
          this.getShowDownValues(index + 1)
        })
      } else {
        this.getShowDownValues(index + 1)
      }
    },
    // 获取用户下属信息
    getBranchUser () {
      let baranchUser = getDecodeStore({ name: 'BaranchUser' })
      if (validatenull(baranchUser)) {
        getBranchUser(this.info.username).then(response => {
          this.isShow = false
          let item = {}
          item.label = this.info.name
          item.username = this.info.username
          this.nextList.push(item)
          this.nextList = downValues(response.data)
          setEncodeStore('BaranchUser', this.nextList)
          this.isShow = true
        })
      } else {
        this.nextList = baranchUser
      }
    },
    // 远程查询得相关条件信息
    remoteMethod (query, index) {
      let option = this.SearchItem.searchList[index]
      dynamic(option.dynamicAddr, query).then(response => {
      })
    },
    // input带输入建议查询
    inputQuerySearch (queryString, cb, index, prop) {
      let option = this.SearchItem.searchList[index]
      dynamic(option.dynamicAddr, queryString).then(response => {
        cb(response.data)
      })
      cb(queryString)
    },
    handleChange (val) {
      this.changeValue = ''
      this.changeValue = val
      this.changeSearch()
    },
    clickSelect (val) {
      this.clickSelectVal = ''
      this.clickSelectVal = val
      this.changeSearch()
    },
    changeSearch () {
      let separeteForm = {
        inputLike: {},
        dateList: {},
        moreList: {},
        oneList: {},
        noinList: this.noinList
      }
      this.SearchItem.searchList.forEach((item, index) => {
        if (item.searchType === 'separeteSearch') {
          if (!validatenull(this.clickSelectVal)) {
            if (this.changeValue === this.clickSelectVal.customerName) {
              separeteForm.oneList[item.prop] = this.changeValue
              separeteForm.inputLike[item.prop] = ''
            } else {
              separeteForm.inputLike[item.prop] = this.changeValue
              separeteForm.oneList[item.prop] = ''
            }
          } else {
            separeteForm.inputLike[item.prop] = this.changeValue
            separeteForm.oneList[item.prop] = ''
          }
          this.separeteSearchForm = separeteForm
          this.searchForm.oneList[item.prop] = separeteForm.oneList[item.prop]
          this.searchForm.inputLike[item.prop] = separeteForm.inputLike[item.prop]
        }
      })
    },
    // 点击查询
    submitForm () {
      this.$emit('searchClick', this.searchForm)
    },
    // 点击重置
    resetForm () {
      this.searchForm = {
        inputLike: {},
        dateList: this.searchForm.dateList,
        moreList: {},
        oneList: {},
        noinList: this.noinList
      }
      this.$emit('searchClick', this.searchForm)
    },
    // 点击自定义查询条件按钮
    onChangeCustomize () {
      this.dialogVisible.isSetting = this.SearchItem.isCustSearch
      this.dialogVisible.DataTransfer = this.SearchItem.searchList
      this.dialogVisible.show = true
    },
    settingClose () {
      this.dialogVisible.show = false
    },
    onSave (values) {
      this.dialogVisible.show = false
      this.SearchItem.searchList = []
      removeStore({ name: 'se' + this.ModularName, type: 'session' })
      removeStore({ name: 'BaranchUser', type: 'session' })
      this.getSearchUI()
    },
    branceChange (val) {
      if (val === 2 && this.nextList.length === 0) {
        this.getBranchUser()
      }
    }
  }
}
</script>

<style lang="scss">
.TdSearch_layout {
  // 搜索框 下外边距设置为16px
  .el-form-item--mini.el-form-item {
    margin-bottom: 10px;
  }
  // label 右内边距设置为8px
  .el-form-item__label {
    padding: 0 8px 0 0;
  }
  // label、日期框内的 至
  .el-form--inline .el-form-item__label,.el-range-editor--mini .el-range-separator {
    font-size: 12px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #343434;
    letter-spacing: 1px;
  }
  // 输入内容框;日期内容框;查询、重置、定义按钮字体
  .el-input--mini .el-input__inner,.el-range-editor--mini .el-range-input,.el-button--mini {
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    letter-spacing: 1px;
  }
  .el-button--primary {
    background: #3A6FCF;
    border-color: #3A6FCF;
    color: #FFF;
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: #5e86ce;
    border-color: #5e86ce;
    color: #FFF;
  }
  .el-button--danger {
    background: #FC4958;
    border-color: #FC4958;
    color: #FFF;
  }
  .el-button--danger:focus, .el-button--danger:hover {
    background: #ff6774;
    border-color: #ff6774;
    color: #FFF;
  }
  .el-button--warning {
    background: #FF972F;
    border-color: #FF972F;
    color: #FFF;
  }
  .el-button--warning:focus, .el-button--warning:hover {
    background: #fdaf61;
    border-color: #fdaf61;
    color: #FFF;
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-query/index.vue"
}
</vue-filename-injector>
